import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
  loading: false,
  updateCustomerData: {},
  error: "",
  success: false,
  status: "",
};

const updateCustomerCall = createAsyncThunk(
  "customer/updateCustomer",
  async (data) => {
    try {
      const result = await axios.post(
        "https://apac.api.capillarytech.com/mobile/v2/api/customer/update?format=json",
        data
      );
  
      return result?.data;
    } catch (err) {
      console.log(err);
    }
  }
);

const updateCustomerSlice = createSlice({
  name: "update-customer",
  initialState,
  reducers: {
    reset: (state, payload) => {
      state.loading = false;
      state.success = false;
      state.error = "";
      state.updateCustomerData = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateCustomerCall.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateCustomerCall.fulfilled, (state, action) => {

      state.loading = false;
      state.updateCustomerData = action.payload?.customers?.customer[0];
      state.success = action.payload?.status?.success === "true" ? true : false;
      state.status = action.payload?.status?.code;
      state.message = action.payload?.status?.message
      state.error = "";
    });
    builder.addCase(updateCustomerCall.rejected, (state, action) => {
      state.loading = false;
      state.updateCustomerData = {};
      state.error = action.error.message;
      state.success = false;
    });
  },
});

export default updateCustomerSlice.reducer;
export const { reset } = updateCustomerSlice.actions;
export { updateCustomerCall };
